import { render, staticRenderFns } from "./InjectionPoint.vue?vue&type=template&id=7ff1186c&scoped=true"
import script from "./InjectionPoint.vue?vue&type=script&lang=js"
export * from "./InjectionPoint.vue?vue&type=script&lang=js"
import style0 from "./InjectionPoint.vue?vue&type=style&index=0&id=7ff1186c&prod&lang=scss&scoped=true"
import style1 from "./InjectionPoint.vue?vue&type=style&index=1&id=7ff1186c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1186c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VTextField})
